export const GAID_URL = process.env.REACT_APP_GAID_URL || 'http://gaid.local';

export const GAID_API_URL = process.env.REACT_APP_GAID_API_URL || 'http://api.gaid.local/api/v1';

export const GAID_GRAPHQL_URL = process.env.REACT_APP_GAID_GRAPHQL_URL || 'http://api.gaid.local/graphql';

